import { get } from 'src/utils/config/lodashUtils'
import { blockedOrgIds } from '../config/config'

export const shouldBlockForUser = (userObj) => {
  return blockedOrgIds.includes(get(userObj, 'org', 'Demo'))
}
